<template>
  <div class="tab-dialog-box" style="position: relative;">
    <el-tabs v-model="activeFragmentId" :before-leave="onFragmentChange">
      <el-tab-pane label="专家详情" name="specialistPage" style="width: 100%;"
                   v-if="checkPermCodeExist('specialistPage:specialistPage')">

        <el-scrollbar class="custom-scroll" :style="{height: getTabPaneHeight + 'px'}">
          <el-form ref="specialistPage" :model="formData" class="full-width-input" style="width: 100%;" :rules="rules"
                   label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
            <div v-if="formData.Specialist.specialistType !=='4' ">
              <el-row :gutter="20">
                <!--            <el-col :span="6">-->
                <!--              <el-form-item label="个人名称" prop="Specialist.userName">-->
                <!--                <el-input class="input-item"  v-model="formData.Specialist.userName"-->
                <!--                           placeholder="个人名称"-->
                <!--                />-->
                <!--                <span class="input-item input-label" v-else>{{formData.Specialist.userName}}</span>-->
                <!--              </el-form-item>-->
                <!--            </el-col>-->
                <el-col :span="8" v-if="formData.Specialist.specialistNo">
                  <el-form-item label="专家编号" prop="Specialist.specialistNo">
                    <el-input   class="input-item"  v-model="formData.Specialist.specialistNo" readOnly

                    />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item :label="myLabel.specialistNameLabel" prop="Specialist.specialistName">
                    <el-input class="input-item"  v-model="formData.Specialist.specialistName"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="证件类型" prop="Specialist.documentType">
                    <el-select class="input-item"  v-model="formData.Specialist.documentType" disabled
                               filterable
                               :loading="flowSpecialistAuditForm.documentType.impl.loading"
                               @visible-change="flowSpecialistAuditForm.documentType.impl.onVisibleChange"
                               @change="onDocumentTypeValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.documentType.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="身份证号码" prop="Specialist.idCard">
                    <el-input class="input-item"  v-model="formData.Specialist.idCard"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="身份" prop="Specialist.identity">
                    <el-select class="input-item"  v-model="formData.Specialist.identity"  filterable
                               :loading="flowSpecialistAuditForm.identity.impl.loading"
                               @visible-change="flowSpecialistAuditForm.identity.impl.onVisibleChange"
                               @change="onIdentityValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.identity.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="籍贯" prop="Specialist.nativePlace">
                    <el-input class="input-item"  v-model="formData.Specialist.nativePlace"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="区级" prop="Specialist.isDistrict">
                    <el-select class="input-item"  v-model="formData.Specialist.isDistrict"  filterable
                               :loading="flowSpecialistAuditForm.isDistrict.impl.loading"
                               @visible-change="flowSpecialistAuditForm.isDistrict.impl.onVisibleChange"
                               @change="onIsDistrictValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.isDistrict.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="政治面貌" prop="Specialist.politicalOutlook">
                    <el-input class="input-item"  v-model="formData.Specialist.politicalOutlook"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="性别" prop="Specialist.gender">
                    <el-select class="input-item" v-model="formData.Specialist.gender"  filterable
                               :loading="flowSpecialistAuditForm.gender.impl.loading"
                               @visible-change="flowSpecialistAuditForm.gender.impl.onVisibleChange"
                               @change="onGenderValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.gender.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" >
                  <el-form-item label="出生日期" prop="Specialist.birthday">
                    <el-date-picker class="input-item"  v-model="formData.Specialist.birthday"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    type="date" align="left"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="产业" prop="Specialist.industryId">
                    <el-cascader class="input-item"  v-model="formData.Specialist.industryId" :options="flowSpecialistAuditForm.industryId.impl.dropdownList" filterable
                                 :show-all-levels="false"
                                 :props="{value: 'id', label: 'name', checkStrictly: true}"
                                 @visible-change="flowSpecialistAuditForm.industryId.impl.onVisibleChange"
                                 @change="onIndustryIdValueChange"
                    />
                  </el-form-item>
                </el-col>
                <!--                <el-col :span="8">-->
                <!--                  <el-form-item label="单位性质" prop="Specialist.companyProperties">-->
                <!--                    <el-input class="input-item"  v-model="formData.Specialist.companyProperties" -->

                <!--                    />-->
                <!--                  </el-form-item>-->
                <!--                </el-col>-->
                <!--                <el-col :span="8">-->
                <!--                  <el-form-item label="服务单位" prop="Specialist.serviceCompany">-->
                <!--                    <el-input class="input-item"  v-model="formData.Specialist.serviceCompany" -->

                <!--                    />-->
                <!--                  </el-form-item>-->
                <!--                </el-col>-->
                <!--                <el-col :span="8">-->
                <!--                  <el-form-item label="工作单位（编制）属地" prop="Specialist.companyArea">-->
                <!--                    <el-input class="input-item"  v-model="formData.Specialist.companyArea" -->

                <!--                    />-->
                <!--                  </el-form-item>-->
                <!--                </el-col>-->
                <el-col :span="8">
                  <el-form-item label="学术称号" prop="Specialist.academicTitle">
                    <el-input class="input-item"  v-model="formData.Specialist.academicTitle"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="电子邮箱" prop="Specialist.email">
                    <el-input class="input-item"  v-model="formData.Specialist.email"

                    />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="学历" prop="Specialist.education">
                    <el-select class="input-item"  v-model="formData.Specialist.education"  filterable
                               :loading="flowSpecialistAuditForm.education.impl.loading"
                               @visible-change="flowSpecialistAuditForm.education.impl.onVisibleChange"
                               @change="onEducationValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.education.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" >
                  <el-form-item label="学位" prop="Specialist.degreeLevel">
                    <el-select class="input-item"  v-model="formData.Specialist.degreeLevel"  filterable
                               :loading="flowSpecialistAuditForm.degreeLevel.impl.loading"
                               @visible-change="flowSpecialistAuditForm.degreeLevel.impl.onVisibleChange"
                               @change="onDegreeLevelValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.degreeLevel.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" >
                  <el-form-item label="职称" prop="Specialist.specialistTitleId">
                    <el-select class="input-item"  v-model="formData.Specialist.specialistTitleId"  filterable
                               :loading="flowSpecialistAuditForm.specialistTitleId.impl.loading"
                               @visible-change="flowSpecialistAuditForm.specialistTitleId.impl.onVisibleChange"
                               @change="onSpecialistTitleIdValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.specialistTitleId.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="联系电话" prop="Specialist.mobilePhone">
                    <el-input class="input-item"  v-model="formData.Specialist.mobilePhone"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8" >
                  <el-form-item label="工作单位（编制）" prop="Specialist.companyName">
                    <el-input class="input-item"  v-model="formData.Specialist.companyName"

                    />
                  </el-form-item>
                </el-col>
<!--                <el-col :span="8" >-->
<!--                  <el-form-item label="统一社会信用代码" prop="Specialist.creditCode">-->
<!--                    <el-input class="input-item"  v-model="formData.Specialist.creditCode"-->

<!--                    />-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
                <el-col :span="8">
                  <el-form-item label="单位性质" prop="Specialist.companyProperties">
                    <el-input class="input-item"  v-model="formData.Specialist.companyProperties"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="工作单位（编制）属地" prop="Specialist.companyArea">
                    <el-input class="input-item"  v-model="formData.Specialist.companyArea"

                    />
                  </el-form-item>
                </el-col>
<!--                <el-col :span="8">-->
<!--                  <el-form-item label="职位" prop="Specialist.companyPost">-->
<!--                    <el-input class="input-item"  v-model="formData.Specialist.companyPost"-->

<!--                    />-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
                <el-col :span="8">
                  <el-form-item label="单位联系人" prop="Specialist.companyContacts">
                    <el-input class="input-item"  v-model="formData.Specialist.companyContacts"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="单位联系电话" prop="Specialist.companyTel">
                    <el-input class="input-item"  v-model="formData.Specialist.companyTel"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="服务单位" prop="Specialist.serviceCompany">
                    <el-input class="input-item"  v-model="formData.Specialist.serviceCompany"

                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row v-if="formData.Specialist.isDistrict === '1'">
                <!--            <div  >-->
                <el-col :span="8">
                  <el-form-item label="工作经费（元）" prop="Specialist.workingFunds">
                    <el-input-number class="input-item"  v-model="formData.Specialist.workingFunds"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="拨付渠道" prop="Specialist.appropriateChannel"
                                v-if="formData.Specialist.workingFunds && formData.Specialist.workingFunds>0">
                    <el-select class="input-item"  v-model="formData.Specialist.appropriateChannel"  filterable
                               :loading="flowSpecialistAuditForm.appropriateChannel.impl.loading"
                               @visible-change="flowSpecialistAuditForm.appropriateChannel.impl.onVisibleChange"
                               @change="onAppropriateChannelValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.appropriateChannel.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="经费拨至单位" prop="Specialist.fundsToCompany"
                                v-if="formData.Specialist.workingFunds && formData.Specialist.workingFunds>0">
                    <el-input class="input-item"  v-model="formData.Specialist.fundsToCompany"

                    />
                  </el-form-item>
                </el-col>
                <!--            </div>-->
              </el-row>
              <el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="myLabel.specialistAvatarLabel" prop="Specialist.specialistAvatar">
                      <el-upload v-if="!readOnly"
                                 class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                                 :action="getUploadActionUrl('/admin/app/specialist/upload')"
                                 :data="{fieldName: 'specialistAvatar', asImage: true}"
                                 :on-success="onSpecialistAvatarUploadSuccess"
                                 :on-remove="onSpecialistAvatarRemoveFile"
                                 :before-upload="pictureFile"
                                 :on-error="onUploadError"
                                 :show-file-list="true"
                                 :on-preview="handlePreview"
                                 :limit="flowSpecialistAuditForm.specialistAvatar.impl.maxCount"
                                 :on-exceed="onUploadLimit"
                                 :file-list="flowSpecialistAuditForm.specialistAvatar.impl.fileList"
                                 list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                      </el-upload>
                      <template v-else>
                        <el-image v-for="item in parseUploadData(formData.Specialist.specialistAvatar, {id: formData.Specialist.id,
                  fieldName: 'specialistAvatar', asImage: true})"
                                  :preview-src-list="getPictureList(formData.Specialist.specialistAvatar, {id: formData.Specialist.id, fieldName: 'specialistAvatar', asImage: true})"
                                  class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                          <div slot="error" class="table-cell-image">
                            <i class="el-icon-picture-outline"></i>
                          </div>
                        </el-image>
                        <!--                  <img v-for="item in flowSpecialistAuditForm.specialistAvatar.impl.fileList" :key="item.url"-->
                        <!--                       class="table-cell-image" :src="item.url" />-->
                      </template>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="身份证正面" prop="Specialist.idPhoto">
                      <el-upload v-if="!readOnly"
                                 class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                                 :action="getUploadActionUrl('/admin/app/specialist/upload')"
                                 :data="{fieldName: 'idPhoto', asImage: true}"
                                 :on-success="onIdPhotoUploadSuccess"
                                 :on-remove="onIdPhotoAvatarRemoveFile"
                                 :before-upload="pictureFile"
                                 :on-error="onUploadError"
                                 :show-file-list="true"
                                 :on-preview="handlePreview"
                                 :limit="flowSpecialistAuditForm.idPhoto.impl.maxCount"
                                 :on-exceed="onUploadLimit"
                                 :file-list="flowSpecialistAuditForm.idPhoto.impl.fileList"
                                 list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                      </el-upload>
                      <template v-else>
                        <el-image v-for="item in parseUploadData(formData.Specialist.idPhoto, {id: formData.Specialist.id,
                  fieldName: 'idPhoto', asImage: true})"
                                  :preview-src-list="getPictureList(formData.Specialist.idPhoto, {id: formData.Specialist.id, fieldName: 'idPhoto', asImage: true})"
                                  class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                          <div slot="error" class="table-cell-image">
                            <i class="el-icon-picture-outline"></i>
                          </div>
                        </el-image>
                        <!--                  <img v-for="item in flowSpecialistAuditForm.idPhoto.impl.fileList" :key="item.url"-->
                        <!--                       class="table-cell-image" :src="item.url" />-->
                      </template>
                    </el-form-item>
                  </el-col>

                  <el-col :span="8">
                    <el-form-item label="三方协议书" prop="SpecialistHis.contractFiles">

                      <template >
                        <el-upload name="uploadFile" :headers="getUploadHeaders" multiple
                                   :action="getUploadActionUrl('/admin/app/specialistHis/upload')"
                                   :data="{fieldName: 'contractFiles', asImage: false}"
                                   :on-success="onContractFilesUploadSuccess"
                                   :on-remove="onContractFilesRemoveFile"
                                   :on-error="onUploadError" :on-exceed="onUploadLimit"
                                   :limit="signContractWin.contractFiles.impl.maxCount"
                                   :file-list="signContractWin.contractFiles.impl.fileList"
                                   :show-file-list="false">
                          <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
                        </el-upload>
                        <div v-if="signContractWin.contractFiles.impl.fileList && signContractWin.contractFiles.impl.fileList[0] != null" style="position: relative">
                          <div v-for="item in signContractWin.contractFiles.impl.fileList" :key="item.url" style="display: inline-flex">
                            <div> {{item.name}}</div>
                            <div style="margin-left: 15px">
                              <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>
                              <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>
                              <el-button type="primary" @click="onContractFilesRemoveFile(null,null)">删除</el-button>
                            </div>

                          </div>
                        </div>
                      </template>
                    </el-form-item>
                  </el-col>

                </el-row>
                <el-row>
                  <el-col :span="8" >
                    <el-form-item label="学历资料" prop="Specialist.educationalFile">
                      <el-upload v-if="!readOnly"
                                 class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                                 :action="getUploadActionUrl('/admin/app/specialist/upload')"
                                 :data="{fieldName: 'educationalFile', asImage: true}"
                                 :on-success="onEducationalFileUploadSuccess"
                                 :on-remove="onEducationalFileRemoveFile"
                                 :before-upload="pictureFile"
                                 :on-error="onUploadError"
                                 :show-file-list="true"
                                 :on-preview="handlePreview"
                                 :limit="flowSpecialistAuditForm.educationalFile.impl.maxCount"
                                 :on-exceed="onUploadLimit"
                                 :file-list="flowSpecialistAuditForm.educationalFile.impl.fileList"
                                 list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                      </el-upload>
                      <template v-else>
                        <el-image v-for="item in parseUploadData(formData.Specialist.educationalFile, {id: formData.Specialist.id,
                  fieldName: 'educationalFile', asImage: true})"
                                  :preview-src-list="getPictureList(formData.Specialist.educationalFile, {id: formData.Specialist.id, fieldName: 'educationalFile', asImage: true})"
                                  class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                          <div slot="error" class="table-cell-image">
                            <i class="el-icon-picture-outline"></i>
                          </div>
                        </el-image>
                        <!--                  <img v-for="item in flowSpecialistAuditForm.educationalFile.impl.fileList" :key="item.url"-->
                        <!--                       class="table-cell-image" :src="item.url" />-->
                      </template>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" >
                    <el-form-item label="学位资料" prop="Specialist.degreeFiles">
                      <el-upload v-if="!readOnly"
                                 class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                                 :action="getUploadActionUrl('/admin/app/specialist/upload')"
                                 :data="{fieldName: 'degreeFiles', asImage: true}"
                                 :on-success="onDegreeFilesUploadSuccess"
                                 :on-remove="onDegreeFilesRemoveFile"
                                 :before-upload="pictureFile"
                                 :on-error="onUploadError"
                                 :show-file-list="true"
                                 :on-preview="handlePreview"
                                 :limit="flowSpecialistAuditForm.degreeFiles.impl.maxCount"
                                 :on-exceed="onUploadLimit"
                                 :file-list="flowSpecialistAuditForm.degreeFiles.impl.fileList"
                                 list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                      </el-upload>
                      <template v-else>
                        <el-image v-for="item in parseUploadData(formData.Specialist.degreeFiles, {id: formData.Specialist.id,
                  fieldName: 'degreeFiles', asImage: true})"
                                  :preview-src-list="getPictureList(formData.Specialist.degreeFiles, {id: formData.Specialist.id, fieldName: 'degreeFiles', asImage: true})"
                                  class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                          <div slot="error" class="table-cell-image">
                            <i class="el-icon-picture-outline"></i>
                          </div>
                        </el-image>
                        <!--                  <img v-for="item in flowSpecialistAuditForm.degreeFiles.impl.fileList" :key="item.url"-->
                        <!--                       class="table-cell-image" :src="item.url" />-->
                      </template>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" >
                    <el-form-item label="职称资料" prop="Specialist.positionalFiles">
                      <el-upload v-if="!readOnly"
                                 class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                                 :action="getUploadActionUrl('/admin/app/specialist/upload')"
                                 :data="{fieldName: 'positionalFiles', asImage: true}"
                                 :on-success="onPositionalFilesUploadSuccess"
                                 :on-remove="onPositionalFilesRemoveFile"
                                 :before-upload="pictureFile"
                                 :on-error="onUploadError"
                                 :show-file-list="true"
                                 :on-preview="handlePreview"
                                 :limit="flowSpecialistAuditForm.positionalFiles.impl.maxCount"
                                 :on-exceed="onUploadLimit"
                                 :file-list="flowSpecialistAuditForm.positionalFiles.impl.fileList"
                                 list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                      </el-upload>
                      <template v-else>
                        <el-image v-for="item in parseUploadData(formData.Specialist.positionalFiles, {id: formData.Specialist.id,
                  fieldName: 'positionalFiles', asImage: true})"
                                  :preview-src-list="getPictureList(formData.Specialist.positionalFiles, {id: formData.Specialist.id, fieldName: 'positionalFiles', asImage: true})"
                                  class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                          <div slot="error" class="table-cell-image">
                            <i class="el-icon-picture-outline"></i>
                          </div>
                        </el-image>
                        <!--                  <img v-for="item in flowSpecialistAuditForm.positionalFiles.impl.fileList" :key="item.url"-->
                        <!--                       class="table-cell-image" :src="item.url" />-->
                      </template>
                    </el-form-item>
                  </el-col>

                </el-row>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="类型" prop="Specialist.specialistType">
                    <el-radio-group class="input-item"  v-model="formData.Specialist.specialistType"
                                    @change="onSpecialistTypeValueChange"
                    >
                      <el-radio v-for="item in flowSpecialistAuditForm.specialistType.impl.dropdownList" :key="item.id"
                                :label="item.id"
                      >
                        {{item.name}}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12" v-if="formData.Specialist.specialistType=='2'">
                  <el-form-item label="团队名称" prop="Specialist.teamName">
                    <el-input class="input-item"  v-model="formData.Specialist.teamName"

                    />
                  </el-form-item>
                </el-col>

                <el-col :span="6" v-if="formData.Specialist.specialistType=='3'">
                  <el-form-item label="法人识别号" prop="Specialist.identityCardNo">
                    <el-input class="input-item"  v-model="formData.Specialist.identityCardNo"

                    />
                  </el-form-item>
                </el-col>

                <el-col :span="24" >
                  <el-form-item label="专业领域" prop="Specialist.specializedField">
                    <el-input class="input-item" v-model="formData.Specialist.specializedField"
                              type="textarea"
                              :autosize="{minRows: 4, maxRows: 8}"

                    />
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item :label="myLabel.specialistSpecialLabel+'(100字以上)'" prop="Specialist.specialistSpecial">
                    <rich-editor ref="specialistSpecial" class="input-item"
                                 v-model="formData.Specialist.specialistSpecial"  />
                  </el-form-item>
                </el-col>

                <el-col :span="24" v-if="true">

                  <el-form-item label="附件" prop="Specialist.otherFiles">

                    <template>
<!--                      <a v-for="item in flowSpecialistAuditForm.otherFiles.impl.fileList" :key="item.url"-->
<!--                         href="javascript:void(0);" @click="downloadFile(item.url, item.name)">-->
<!--                        {{item.name}}-->
<!--                      </a>-->
                      <el-upload  name="uploadFile" :headers="getUploadHeaders" multiple
                                 :action="getUploadActionUrl('/admin/app/specialist/upload')"
                                 :data="{fieldName: 'otherFiles', asImage: false}"
                                 :on-success="onOtherFilesUploadSuccess"
                                 :on-remove="onOtherFilesRemoveFile"
                                 :on-error="onUploadError" :on-exceed="onUploadLimit"
                                 :limit="flowSpecialistAuditForm.otherFiles.impl.maxCount"
                                 :file-list="flowSpecialistAuditForm.otherFiles.impl.fileList"
                                 :show-file-list="false">
                        <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
                      </el-upload>
                      <div v-if="flowSpecialistAuditForm.otherFiles.impl.fileList && flowSpecialistAuditForm.otherFiles.impl.fileList[0] != null" style="position: relative">
                        <div v-for="(item,index) in flowSpecialistAuditForm.otherFiles.impl.fileList" :key="item.url"
                             style="display:flex;margin-top: 5px;">
                          <div> {{item.name}}</div>
                          <div style="margin-left: 15px;display: inline-flex">

                            <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>
                            <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>
                            <el-button type="primary"
                                       @click="deleteOtherFiles(item,flowSpecialistAuditForm.otherFiles.impl.fileList,index)">删除</el-button>
                          </div>

                        </div>
                      </div>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="24" v-if="formData.Specialist.specialistType=='2'">
                  <el-row type="flex" justify="space-between" align="middle" style="margin-bottom: 15px;">
                    <div class="table-title" style="padding-left: 5px; border-left: 3px solid #409EFF;">成员信息</div>
                    <!-- 表格操作 -->
                    <div>
                    </div>
                  </el-row>
                </el-col>
                              <el-col :span="24" v-if="formData.Specialist.specialistType=='2'">
                                <filter-box :item-width="350">
                                  <el-button slot="operator" type="primary" :size="defaultFormItemSize"
                                             @click="addSpecialistMember()"  >
                                    新增成员
                                  </el-button>
                                </filter-box>
                              </el-col>
                <template v-if="formData.Specialist.specialistType=='2'">
                  <el-table ref="specialistMember" :data="flowSpecialistAuditForm.SpecialistMember.impl.dataList" :size="defaultFormItemSize" @sort-change="flowSpecialistAuditForm.SpecialistMember.impl.onSortChange"
                            header-cell-class-name="table-header-gray" v-if="formData.Specialist.specialistType=='2'"
                  >
                    <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="flowSpecialistAuditForm.SpecialistMember.impl.getTableIndex" />
                    <el-table-column label="专家名称" prop="specialistName">
                    </el-table-column>
                    <el-table-column label="专家照片" min-width="100px">
                      <template slot-scope="scope">
                        <el-image v-for="item in parseUploadData(scope.row.specialistAvatar, {id: scope.row.id, fieldName: 'specialistAvatar', asImage: true})"
                                  :preview-src-list="getPictureList(scope.row.specialistAvatar, {id: scope.row.id, fieldName: 'specialistAvatar', asImage: true})"
                                  class="table-cell-image" :key="item.url" :src="item.url" fit="fill">
                          <div slot="error" class="table-cell-image">
                            <i class="el-icon-picture-outline"></i>
                          </div>
                        </el-image>
                      </template>
                    </el-table-column>
                    <el-table-column label="联系电话" prop="mobilePhone">
                    </el-table-column>
                    <el-table-column label="产业" prop="industryName">
                    </el-table-column>
                    <el-table-column label="职称" prop="specialistTitle">
                    </el-table-column>

                    <el-table-column label="操作" fixed="right">
                      <template slot-scope="scope">
                        <el-button @click.stop="onDeleteClick(scope.row, scope.$index)" type="text" :size="defaultFormItemSize" >
                          删除
                        </el-button>
                        <el-button @click.stop="onSpecialistMemberEditClick(scope.row, scope.$index)" type="text" :size="defaultFormItemSize" >
                          编辑
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-row type="flex" justify="end" style="margin-top: 10px;" v-if="formData.Specialist.specialistType=='2'">
                    <el-pagination @size-change="handleSizeChange"
                                   @current-change="handleCurrentChange"
                                   :current-page="currentPage"
                                   :page-sizes="pageSizes"
                                   :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper"
                                   :total="flowSpecialistAuditForm.SpecialistMember.impl.totalCount">
                    </el-pagination>
                  </el-row>
                </template>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="服务对象" prop="SpecialistHis.serviceObjectName">
                    <el-input class="input-item" v-model="formData.SpecialistHis.serviceObjectName"

                    />

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="服务地区" prop="SpecialistHis.serviceAreaId">
                    <el-cascader class="input-item"  v-model="formData.SpecialistHis.serviceAreaId"
                                 style="color: #303133"
                                 :options="signContractWin.serviceAreaId.impl.dropdownList" filterable
                                 :show-all-levels="true"
                                 :props="{value: 'id', label: 'name', checkStrictly: true}"
                                 @visible-change="signContractWin.serviceAreaId.impl.onVisibleChange"
                                 @change="onServiceAreaIdValueChange"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="服务详细地址" prop="SpecialistHis.serviceAddress">
                    <el-input class="input-item" v-model="formData.SpecialistHis.serviceAddress"

                    />

                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="联系人" prop="SpecialistHis.contactsUser">
                    <el-input class="input-item" v-model="formData.SpecialistHis.contactsUser"

                    />

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系电话" prop="SpecialistHis.contactsUserTel">
                    <el-input class="input-item" v-model="formData.SpecialistHis.contactsUserTel"

                    />

                  </el-form-item>
                </el-col>
<!--                <el-col :span="24">-->
<!--                  <el-form-item label="主营业务" prop="SpecialistHis.mainBusiness">-->
<!--                    <el-input class="input-item" v-model="formData.SpecialistHis.mainBusiness"-->
<!--                              type="textarea"-->
<!--                              :autosize="{minRows: 4, maxRows: 8}"-->

<!--                    />-->

<!--                  </el-form-item>-->
<!--                </el-col>-->
<!--                <el-col :span="12">-->
<!--                  <el-form-item label="服务期" prop="SpecialistHis.signYear">-->
<!--                    <el-date-picker class="input-item" v-model="formData.SpecialistHis.signYear"-->
<!--                                    format="yyyy"-->
<!--                                    value-format="yyyy-MM-dd"-->
<!--                                    type="year" align="left"-->

<!--                    />-->

<!--                  </el-form-item>-->
<!--                </el-col>-->
                <el-col :span="12">
                  <el-form-item label="服务期起止" prop="SpecialistHis.signYearStart">
                    <el-date-picker class="input-item" v-model="formData.SpecialistHis.signYearStart"
                                    :clearable="true"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    type="date" align="left"
                                    placeholder="服务期起止"
                    />

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="服务期结束" prop="SpecialistHis.signYearEnd">
                    <el-date-picker class="input-item" v-model="formData.SpecialistHis.signYearEnd" :clearable="true"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    type="date" align="left"
                                    placeholder="服务期结束"
                    />

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="服务对象需求" prop="SpecialistHis.serviceUserRequirement">
                    <el-input class="input-item" v-model="formData.SpecialistHis.serviceUserRequirement"

                    />

                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="服务方式" prop="SpecialistHis.serviceType">
                    <el-input class="input-item" v-model="formData.SpecialistHis.serviceType"
                              type="textarea"
                              :autosize="{minRows: 4, maxRows: 8}"
                    />

                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="服务内容" prop="SpecialistHis.serviceContent">
                    <el-input class="input-item" v-model="formData.SpecialistHis.serviceContent"
                              type="textarea"
                              :autosize="{minRows: 4, maxRows: 8}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24" >
                  <el-form-item label="服务单位营业执照" prop="Specialist.servicePhoto">
                    <el-upload v-if="!readOnly"
                               class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                               :action="getUploadActionUrl('/admin/app/specialist/upload')"
                               :data="{fieldName: 'servicePhoto', asImage: true}"
                               :on-success="onServicePhotoUploadSuccess"
                               :on-remove="onServicePhotoRemoveFile"
                               :before-upload="pictureFile"
                               :on-error="onUploadError"
                               :show-file-list="true"
                               :on-preview="handlePreview"
                               :limit="flowSpecialistAuditForm.servicePhoto.impl.maxCount"
                               :on-exceed="onUploadLimit"
                               :file-list="flowSpecialistAuditForm.servicePhoto.impl.fileList"
                               list-type="picture">
                      <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <template v-else>
                      <el-image v-for="item in parseUploadData(formData.Specialist.servicePhoto, {id: formData.Specialist.id,
                  fieldName: 'servicePhoto', asImage: true})"
                                :preview-src-list="getPictureList(formData.Specialist.servicePhoto, {id: formData.Specialist.id, fieldName: 'servicePhoto', asImage: true})"
                                class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                        <div slot="error" class="table-cell-image">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                      <!--                  <img v-for="item in flowSpecialistAuditForm.servicePhoto.impl.fileList" :key="item.url"-->
                      <!--                       class="table-cell-image" :src="item.url" />-->
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="服务其他附件" prop="SpecialistHis.attachedFiles">

                    <template >
                      <el-upload name="uploadFile" :headers="getUploadHeaders" multiple
                                 :action="getUploadActionUrl('/admin/app/specialistHis/upload')"
                                 :data="{fieldName: 'attachedFiles', asImage: false}"
                                 :on-success="onAttachedFilesUploadSuccess"
                                 :on-remove="onAttachedFilesRemoveFile"
                                 :on-error="onUploadError" :on-exceed="onUploadLimit"
                                 :limit="signContractWin.attachedFiles.impl.maxCount"
                                 :file-list="signContractWin.attachedFiles.impl.fileList"
                                 :show-file-list="false">
                        <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
                      </el-upload>
                      <div v-if="signContractWin.attachedFiles.impl.fileList && signContractWin.attachedFiles.impl.fileList[0] != null" style="position: relative">
                        <div v-for="(item,index) in signContractWin.attachedFiles.impl.fileList" :key="item.url"
                             style="display:flex;margin-top: 5px;">
                          <div> {{item.name}}</div>
                          <div style="margin-left: 15px;display: inline-flex">

                            <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>
                            <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>
                            <el-button type="primary"
                                       @click="deleteAttachedFiles(item,signContractWin.attachedFiles.impl.fileList,index)">删除</el-button>
                          </div>

                        </div>
                      </div>
                    </template>
                  </el-form-item>
                </el-col>

              </el-row>
            </div>
            <div v-if="formData.Specialist.specialistType ==='4'">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="类型" prop="Specialist.specialistType">
                    <el-radio-group class="input-item"  v-model="formData.Specialist.specialistType"
                                    @change="onSpecialistTypeValueChange"
                    >
                      <el-radio v-for="item in flowSpecialistAuditForm.specialistType.impl.dropdownList" :key="item.id"
                                :label="item.id"
                      >
                        {{item.name}}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8" v-if="formData.Specialist.specialistNo">
                  <el-form-item label="专家编号" prop="Specialist.specialistNo">
                    <el-input   class="input-item"  v-model="formData.Specialist.specialistNo"

                    />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item :label="myLabel.specialistNameLabel" prop="Specialist.specialistName">
                    <el-input class="input-item"  v-model="formData.Specialist.specialistName"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="证件类型" prop="Specialist.documentType">
                    <el-select class="input-item"  v-model="formData.Specialist.documentType"
                               filterable
                               :loading="flowSpecialistAuditForm.documentType.impl.loading"
                               @visible-change="flowSpecialistAuditForm.documentType.impl.onVisibleChange"
                               @change="onDocumentTypeValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.documentType.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="身份证号码" prop="Specialist.idCard">
                    <el-input class="input-item"  v-model="formData.Specialist.idCard"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="性别" prop="Specialist.gender">
                    <el-select class="input-item" v-model="formData.Specialist.gender"  filterable
                               :loading="flowSpecialistAuditForm.gender.impl.loading"
                               @visible-change="flowSpecialistAuditForm.gender.impl.onVisibleChange"
                               @change="onGenderValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.gender.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" >
                  <el-form-item label="出生日期" prop="Specialist.birthday">
                    <el-date-picker class="input-item"  v-model="formData.Specialist.birthday"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    type="date" align="left"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="产业" prop="Specialist.industryId">
                    <el-cascader class="input-item"  v-model="formData.Specialist.industryId" :options="flowSpecialistAuditForm.industryId.impl.dropdownList" filterable
                                 :show-all-levels="false"
                                 :props="{value: 'id', label: 'name', checkStrictly: true}"
                                 @visible-change="flowSpecialistAuditForm.industryId.impl.onVisibleChange"
                                 @change="onIndustryIdValueChange"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="学历" prop="Specialist.education">
                    <el-select class="input-item"  v-model="formData.Specialist.education"  filterable
                               :loading="flowSpecialistAuditForm.education.impl.loading"
                               @visible-change="flowSpecialistAuditForm.education.impl.onVisibleChange"
                               @change="onEducationValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.education.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" >
                  <el-form-item label="工作单位（编制）" >
                    <el-input class="input-item"  v-model="formData.Specialist.companyName"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8" >
                  <el-form-item label="统一社会信用代码" >
                    <el-input class="input-item"  v-model="formData.Specialist.creditCode"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="单位联系电话" >
                    <el-input class="input-item"  v-model="formData.Specialist.companyTel"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="服务单位" >
                    <el-input class="input-item"  v-model="formData.Specialist.serviceCompany"

                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="myLabel.specialistAvatarLabel" prop="Specialist.specialistAvatar">
                    <el-upload v-if="!readOnly"
                               class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                               :action="getUploadActionUrl('/admin/app/specialist/upload')"
                               :data="{fieldName: 'specialistAvatar', asImage: true}"
                               :on-success="onSpecialistAvatarUploadSuccess"
                               :on-remove="onSpecialistAvatarRemoveFile"
                               :before-upload="pictureFile"
                               :on-error="onUploadError"
                               :show-file-list="true"
                               :on-preview="handlePreview"
                               :limit="flowSpecialistAuditForm.specialistAvatar.impl.maxCount"
                               :on-exceed="onUploadLimit"
                               :file-list="flowSpecialistAuditForm.specialistAvatar.impl.fileList"
                               list-type="picture">
                      <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <template v-else>
                      <el-image v-for="item in parseUploadData(formData.Specialist.specialistAvatar, {id: formData.Specialist.id,
                  fieldName: 'specialistAvatar', asImage: true})"
                                :preview-src-list="getPictureList(formData.Specialist.specialistAvatar, {id: formData.Specialist.id, fieldName: 'specialistAvatar', asImage: true})"
                                class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                        <div slot="error" class="table-cell-image">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                      <!--                  <img v-for="item in flowSpecialistAuditForm.specialistAvatar.impl.fileList" :key="item.url"-->
                      <!--                       class="table-cell-image" :src="item.url" />-->
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="身份证正面" prop="Specialist.idPhoto">
                    <el-upload v-if="!readOnly"
                               class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                               :action="getUploadActionUrl('/admin/app/specialist/upload')"
                               :data="{fieldName: 'idPhoto', asImage: true}"
                               :on-success="onIdPhotoUploadSuccess"
                               :on-remove="onIdPhotoAvatarRemoveFile"
                               :before-upload="pictureFile"
                               :on-error="onUploadError"
                               :show-file-list="true"
                               :on-preview="handlePreview"
                               :limit="flowSpecialistAuditForm.idPhoto.impl.maxCount"
                               :on-exceed="onUploadLimit"
                               :file-list="flowSpecialistAuditForm.idPhoto.impl.fileList"
                               list-type="picture">
                      <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <template v-else>
                      <el-image v-for="item in parseUploadData(formData.Specialist.idPhoto, {id: formData.Specialist.id,
                  fieldName: 'idPhoto', asImage: true})"
                                :preview-src-list="getPictureList(formData.Specialist.idPhoto, {id: formData.Specialist.id, fieldName: 'idPhoto', asImage: true})"
                                class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                        <div slot="error" class="table-cell-image">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                      <!--                  <img v-for="item in flowSpecialistAuditForm.idPhoto.impl.fileList" :key="item.url"-->
                      <!--                       class="table-cell-image" :src="item.url" />-->
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="8" >
                  <el-form-item label="服务单位营业执照" >
                    <el-upload v-if="!readOnly"
                               class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                               :action="getUploadActionUrl('/admin/app/specialist/upload')"
                               :data="{fieldName: 'servicePhoto', asImage: true}"
                               :on-success="onServicePhotoUploadSuccess"
                               :on-remove="onServicePhotoRemoveFile"
                               :before-upload="pictureFile"
                               :on-error="onUploadError"
                               :show-file-list="true"
                               :on-preview="handlePreview"
                               :limit="flowSpecialistAuditForm.servicePhoto.impl.maxCount"
                               :on-exceed="onUploadLimit"
                               :file-list="flowSpecialistAuditForm.servicePhoto.impl.fileList"
                               list-type="picture">
                      <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <template v-else>
                      <el-image v-for="item in parseUploadData(formData.Specialist.servicePhoto, {id: formData.Specialist.id,
                  fieldName: 'servicePhoto', asImage: true})"
                                :preview-src-list="getPictureList(formData.Specialist.servicePhoto, {id: formData.Specialist.id, fieldName: 'servicePhoto', asImage: true})"
                                class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                        <div slot="error" class="table-cell-image">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                      <!--                  <img v-for="item in flowSpecialistAuditForm.servicePhoto.impl.fileList" :key="item.url"-->
                      <!--                       class="table-cell-image" :src="item.url" />-->
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="专长(100字以上)" prop="Specialist.specialistSpecial">
                    <rich-editor ref="specialistSpecial" class="input-item"
                                 v-model="formData.Specialist.specialistSpecial"  />
                  </el-form-item>
                </el-col>
                <el-col :span="24" v-if="true">

                  <el-form-item label="成果与荣誉" prop="Specialist.otherFiles">

                    <template>
<!--                      <a v-for="item in flowSpecialistAuditForm.otherFiles.impl.fileList" :key="item.url"-->
<!--                         href="javascript:void(0);" @click="downloadFile(item.url, item.name)">-->
<!--                        {{item.name}}-->
<!--                      </a>-->
                      <el-upload  name="uploadFile" :headers="getUploadHeaders" multiple
                                  :action="getUploadActionUrl('/admin/app/specialist/upload')"
                                  :data="{fieldName: 'otherFiles', asImage: false}"
                                  :on-success="onOtherFilesUploadSuccess"
                                  :on-remove="onOtherFilesRemoveFile"
                                  :on-error="onUploadError" :on-exceed="onUploadLimit"
                                  :limit="flowSpecialistAuditForm.otherFiles.impl.maxCount"
                                  :file-list="flowSpecialistAuditForm.otherFiles.impl.fileList"
                                  :show-file-list="false">
                        <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
                      </el-upload>
                      <div v-if="flowSpecialistAuditForm.otherFiles.impl.fileList && flowSpecialistAuditForm.otherFiles.impl.fileList[0] != null" style="position: relative">
                        <div v-for="(item,index) in flowSpecialistAuditForm.otherFiles.impl.fileList" :key="item.url"
                             style="display:flex;margin-top: 5px;">
                          <div> {{item.name}}</div>
                          <div style="margin-left: 15px;display: inline-flex">

                            <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>
                            <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>
                            <el-button type="primary"
                                       @click="deleteOtherFiles(item,flowSpecialistAuditForm.otherFiles.impl.fileList,index)">删除</el-button>
                          </div>

                        </div>
                      </div>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>

            </div>

          </el-form>
          <el-col :span="24" >
            <el-row class="no-scroll flex-box" type="flex" justify="center">
              <el-button type="primary" :size="defaultFormItemSize"
                         @click="saveSpecialist()">
                保存
              </el-button>
            </el-row>
          </el-col>
        </el-scrollbar>
      </el-tab-pane>
      <el-tab-pane label="服务历史" name="hisTab" style="width: 100%;"
                   v-if="checkPermCodeExist('specialistPage:hisTab') && formData.Specialist.specialistType !=='4'">
        <el-scrollbar class="custom-scroll" :style="{height: getTabPaneHeight + 'px'}">
          <el-form ref="hisTab" :model="formData" class="full-width-input" style="width: 100%;"
                   label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
            <el-row :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="specialistHis" :data="hisTab.SpecialistHis.impl.dataList" :size="defaultFormItemSize" @sort-change="hisTab.SpecialistHis.impl.onSortChange"
                          header-cell-class-name="table-header-gray"
                          highlight-current-row @current-change="hisTab.SpecialistHis.impl.currentRowChange"
                >
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="hisTab.SpecialistHis.impl.getTableIndex" />
                  <el-table-column label="服务对象" prop="serviceObjectName">
                  </el-table-column>
                  <el-table-column label="服务地区" prop="serviceAreaIdDictMap.name">
                  </el-table-column>
                  <el-table-column label="服务对象联系人" prop="contactsUser">
                  </el-table-column>
                  <el-table-column label="联系人电话" prop="contactsUserTel">
                  </el-table-column>
                  <el-table-column label="服务期" prop="signYear">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.signYear, 'day')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                      <el-button @click.stop="onSignContractWinClick(scope.row)" type="text" :size="defaultFormItemSize"
                                 :="!checkPermCodeExist('specialistPage:hisTab:signContractWin')">
                        查看编辑
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-row type="flex" justify="end" style="margin-top: 10px;">
                  <el-pagination
                    :total="hisTab.SpecialistHis.impl.totalCount"
                    :current-page="hisTab.SpecialistHis.impl.currentPage"
                    :page-size="hisTab.SpecialistHis.impl.pageSize"
                    :page-sizes="[10, 20, 50, 100]"
                    layout="total, prev, pager, next, sizes"
                    @current-change="hisTab.SpecialistHis.impl.onCurrentPageChange"
                    @size-change="hisTab.SpecialistHis.impl.onPageSizeChange">
                  </el-pagination>
                </el-row>
              </el-col>
            </el-row>
          </el-form>
        </el-scrollbar>
      </el-tab-pane>
    </el-tabs>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable-next-line */
  import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
  import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
  import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
  import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
  import { SpecialistHisController, SpecialistController, DictionaryController } from '@/api';
import signContractWin from '@/views/specialist/signContractWin.vue';
import specialistMemberEdit from './specialistMemberEdit';
import specialistMemberForm from './specialistMemberForm';
// import {formatDate} from "element-ui/src/utils/date-util";
import { validateSfz } from '@/utils/validateSfz.js';
export default {
  name: 'specialistPage',
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')

  },
  props: {
    id: {
      default: undefined
    },
    viewFlag: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      imgViewerVisible: false,
      imgList: [],
      // 默认显示第几页
      currentPage: 1,
      // 总条数
      totalCount: 1,
      // 个数选择器
      pageSizes: [10, 15, 20, 30],
      // 默认每页显示的条数
      PageSize: 10,
      activeFragmentId: undefined,
      fit: 'scale-down',
      formData: {
        SpecialistHis: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          specialistId: undefined,
          specialistName: undefined,
          serviceObjectName: undefined,
          serviceAreaId: undefined,
          serviceAreaName: undefined,
          contactsUser: undefined,
          contactsUserTel: undefined,
          mainBusiness: undefined,
          signYear: undefined,
          serviceUserRequirement: undefined,
          serviceType: undefined,
          serviceContent: undefined,
          contractFiles: undefined,
          attachedFiles: undefined,
          isDatasourceInit: false
        },
        Specialist: {
          specialistMemberList: [],
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          specialistType: undefined,
          specialistName: undefined,
          teamName: undefined,
          specialistAvatar: undefined,
          mobilePhone: undefined,
          gender: undefined,
          specialistSpecial: undefined,
          companyName: undefined,
          specialistTitle: undefined,
          companyTel: undefined,
          birthday: undefined,
          educationalFile: undefined,
          companyContacts: undefined,
          companyPost: undefined,
          degreeFiles: undefined,
          specialistTitleId: undefined,
          companyContactsTel: undefined,
          degreeLevel: undefined,
          positionalFiles: undefined,
          otherFiles: undefined,
          auditStatus: undefined,
          hotFlag: undefined,
          userId: undefined,
          areaId: undefined,
          hotScore: undefined,
          industryName: undefined,
          relateId: undefined,
          areaName: undefined,
          industryId: undefined,
          specializedField: undefined,
          starFlag: undefined,
          stationIds: undefined,
          associationStation: undefined,
          identityCardNo: undefined,
          mainBusiness: undefined,
          serviceType: undefined,
          serviceContent: undefined,
          serviceObjectName: undefined,
          signYear: undefined,
          serviceAreaId: undefined,
          serviceAreaName: undefined,
          contactsUser: undefined,
          contactsUserTel: undefined,
          serviceUserRequirement: undefined,
          isDatasourceInit: false,
          servicePhoto: undefined
        }
      },
      rules: {
        'Specialist.specialistName': [
          {required: true, message: '请输入姓名', trigger: 'change'}
        ],
        'Specialist.birthday': [
          {required: true, message: '请选择出生日期', trigger: 'change'}
        ],
        'Specialist.industryId': [
          {required: true, message: '请选择专业领域', trigger: 'change'}
        ],
        'Specialist.mobilePhone': [
          {required: true, message: '请输入联系电话', trigger: 'change'}
        ],

        'Specialist.teamName': [
          {required: true, message: '请输入团队名称', trigger: 'change'}
        ],
        'Specialist.identityCardNo': [
          {required: true, message: '请输入法人识别号', trigger: 'change'}
        ],
        'Specialist.idCard': [
          {required: true, validator: validateSfz, trigger: 'change'}
        ],
        'Specialist.companyName': [
          {required: true, message: '请输入工作单位', trigger: 'change'}
        ],
        'Specialist.companyPost': [
          {required: true, message: '请输入职位', trigger: 'change'}
        ],
        'Specialist.companyContacts': [
          {required: true, message: '请输入单位联系人', trigger: 'change'}
        ],
        'Specialist.companyTel': [
          {required: true, message: '请输入单位联系电话', trigger: 'change'}
        ],
        'Specialist.degreeLevel': [
          {required: true, message: '请选择学位', trigger: 'change'}
        ],
        'Specialist.specialistTitleId': [
          {required: true, message: '请选择职称', trigger: 'change'}
        ],
        // 'Specialist.isDistrict': [
        //   {required: true, message: '请选择是否区级', trigger: 'change'}
        // ],
        'Specialist.workingFunds': [
          {required: true, message: '请输入工作经费', trigger: 'change'}
        ],
        'Specialist.appropriateChannel': [
          {required: true, message: '请输入拨付渠道', trigger: 'change'}
        ],
        'Specialist.fundsToCompany': [
          {required: true, message: '请输入经费拨至单位名称', trigger: 'change'}
        ],
        'Specialist.education': [
          {required: true, message: '请输入学历', trigger: 'change'}
        ],
        'Specialist.documentType': [
          {required: true, message: '请选择证件类型', trigger: 'change'}
        ],
        'Specialist.specialistType': [
          {required: true, message: '请选择类型', trigger: 'change'}
        ],
        'Specialist.nativePlace': [
          {required: true, message: '请输入籍贯', trigger: 'change'}
        ],
        'Specialist.identity': [
          {required: true, message: '请输入身份', trigger: 'change'}
        ],
        'Specialist.nation': [
          {required: true, message: '请输入民族', trigger: 'change'}
        ],
        'Specialist.politicalOutlook': [
          {required: true, message: '请输入政治面貌', trigger: 'change'}
        ],
        'SpecialistHis.serviceObjectName': [
          {required: true, message: '请输入服务对象', trigger: 'change'}
        ],
        // 'Specialist.serviceCompany': [
        //   {required: true, message: '请输入服务单位', trigger: 'change'}
        // ],
        'Specialist.companyArea': [
          {required: true, message: '请输入工作单位属地', trigger: 'change'}
        ],
        'Specialist.gender': [
          {required: true, message: '请选择性别', trigger: 'change'}
        ],
        'Specialist.companyProperties': [
          {required: true, message: '请输入单位性质', trigger: 'change'}
        ],
        // 'Specialist.educationalFile': [
        //   {required: true, message: '请上传学历资料', trigger: 'change'}
        // ],
        // 'Specialist.degreeFiles': [
        //   {required: true, message: '请上传学位资料', trigger: 'change'}
        // ],
        // 'Specialist.positionalFiles': [
        //   {required: true, message: '请上传职称资料', trigger: 'change'}
        // ],
        'Specialist.servicePhoto': [
          {required: true, message: '请上传服务单位营业执照'}
        ],
        'Specialist.specialistAvatar': [
          {required: true, message: '请上传照片', trigger: 'change'}
        ],
        'Specialist.idPhoto': [
          {required: true, message: '请上传身份证正面'}
        ],
        'Specialist.creditCode': [
          {required: true, message: '统一社会信用代码', trigger: 'change'}
        ],
        'Specialist.specialistSpecial': [
          {required: true, message: '请输入简介'}
        ],
        'SpecialistHis.serviceAreaId': [
          {required: true, message: '请选择所在地区', trigger: 'change'}
        ],
        'SpecialistHis.contactsUser': [
          {required: true, message: '请输入服务对象联系人', trigger: 'change'}
        ],
        'SpecialistHis.contactsUserTel': [
          {required: true, message: '请输入服务对象联系人电话', trigger: 'change'}
        ],

        // 'SpecialistHis.mainBusiness': [
        //   {required: true, message: '请填写服务对象主营业务', trigger: 'change'}
        // ],
        'SpecialistHis.identityCardNo': [
          {required: true, message: '请输入法人识别号', trigger: 'change'}
        ],
        'SpecialistHis.contractFiles': [
          {required: true, message: '请上传三方协议', trigger: 'change'}
        ],
        'SpecialistHis.signYear': [
          {required: true, message: '请选择服务期', trigger: 'change'}
        ],
        'SpecialistHis.signYearStart': [
          {required: true, message: '请选择服务期起止', trigger: 'change'}
        ],
        'SpecialistHis.signYearEnd': [
          {required: true, message: '请选择服务期结束', trigger: 'change'}
        ]

      },
      signContractWin: {
        formFilter: {
        },
        formFilterCopy: {
        },
        serviceAreaId: {
          impl: new DropdownWidget(this.loadServiceAreaIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        contractFiles: {
          impl: new UploadWidget(1)
        },
        attachedFiles: {
          impl: new UploadWidget(10)
        },
        menuBlock: {
          isInit: false
        },
        isInit: false
      },
      flowSpecialistAuditForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        appropriateChannel: {
          impl: new DropdownWidget(this.loadAppropriateChannelDropdownList)
        },
        specialistType: {
          impl: new DropdownWidget(this.loadSpecialistTypeDropdownList)
        },
        specialistAvatar: {
          impl: new UploadWidget(1)
        },
        idPhoto: {
          impl: new UploadWidget(1)
        },
        gender: {
          impl: new DropdownWidget(this.loadGenderDropdownList)
        },
        industryId: {
          impl: new DropdownWidget(this.loadIndustryIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        degreeLevel: {
          impl: new DropdownWidget(this.loadDegreeLevelDropdownList)
        },
        education: {
          impl: new DropdownWidget(this.loadEducationDropdownList)
        },
        specialistTitleId: {
          impl: new DropdownWidget(this.loadSpecialistTitleIdDropdownList)
        },
        educationalFile: {
          impl: new UploadWidget(1)
        },
        degreeFiles: {
          impl: new UploadWidget(1)
        },
        positionalFiles: {
          impl: new UploadWidget(1)
        },
        servicePhoto: {
          impl: new UploadWidget(1)
        },
        // serviceAreaId: {
        //   impl: new DropdownWidget(this.loadServiceAreaIdDropdownList, true, 'id', 'parentId'),
        //   value: []
        // },
        otherFiles: {
          impl: new UploadWidget(10)
        },
        stationIds: {
          impl: new DropdownWidget(this.loadStationIdsDropdownList)
        },
        areaId: {
          impl: new DropdownWidget(this.loadAreaIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        hotFlag: {
          impl: new DropdownWidget(this.loadHotFlagDropdownList)
        },
        starFlag: {
          impl: new DropdownWidget(this.loadStarFlagDropdownList)
        },
        SpecialistMember: {
          impl: new TableWidget(this.loadSpecialistMemberWidgetData, this.loadSpecialistMemberVerify, true, false)
        },
        documentType: {
          impl: new DropdownWidget(this.loadDocumentTypeDropdownList)
        },
        identity: {
          impl: new DropdownWidget(this.loadIdentityDropdownList)
        },
        isDistrict: {
          impl: new DropdownWidget(this.loadIsDistrictDropdownList)
        },
        isInit: false
      },
      myLabel: {
        specialistNameLabel: '姓名',
        specialistAvatarLabel: '照片',
        specialistSpecialLabel: '专家特长简介',
        identityCardNoLabel: '身份证号'
      },
      myFlag: {
        birthdayFlag: true
      },
      hisTab: {
        formFilter: {
        },
        formFilterCopy: {
        },
        SpecialistHis: {
          impl: new TableWidget(this.loadSpecialistHisWidgetData, this.loadSpecialistHisVerify, true, true, 'createTime', 1)
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    /**
       * 专家类型下拉数据获取函数
       */
    loadSpecialistTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSpecialistTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 拨付渠道下拉数据获取函数
     */
    loadAppropriateChannelDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAppropriateChannelDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 专家类型选中值改变
       */
    onSpecialistTypeValueChange (value) {
      /* if (value === '2') {
          // 团队
          this.myLabel.specialistNameLabel = '发起人姓名';
          this.myLabel.specialistSpecialLabel = '团队简介';
        } else if (value === '3') {
          // 法人
          this.myLabel.specialistNameLabel = '法人名称';
          this.myLabel.specialistSpecialLabel = '法人简介';
        } else {
          this.myLabel.specialistNameLabel = '姓名';
          this.myLabel.specialistSpecialLabel = '专家特长简介';
        } */

      if (value === '2') {
        // 团队
        this.myLabel.specialistNameLabel = '发起人姓名';
        this.myLabel.specialistSpecialLabel = '团队简介';
        this.rules['Specialist.identityCardNo'] = [{ required: false, message: '请输入法人识别号', trigger: 'change' }]
        this.$refs.specialistPage.validateField('Specialist.identityCardNo')
        this.rules['Specialist.teamName'] = [{ required: true, message: '请输入团队名称', trigger: 'change' }]
        this.rules['Specialist.industryId'] = [{ required: true, message: '请选择专业领域', trigger: 'change' }]
        this.rules['Specialist.birthday'] = [{ required: false, message: '请选择出生日期', trigger: 'change' }]
        this.$refs.specialistPage.validateField('Specialist.birthday')
        this.rules['Specialist.mobilePhone'] = [{ required: true, message: '请输入联系电话', trigger: 'change' }]
      } else if (value === '3') {
        // 法人
        this.myLabel.specialistNameLabel = '法人名称';
        this.myLabel.specialistSpecialLabel = '法人简介';
        this.rules['Specialist.identityCardNo'] = [{ required: true, message: '请输入法人识别号', trigger: 'change' }]
        this.rules['Specialist.teamName'] = [{ required: false, message: '请输入团队名称', trigger: 'change' }]
        this.$refs.specialistPage.validateField('Specialist.teamName')
        this.rules['Specialist.industryId'] = [{ required: false, message: '请选择专业领域', trigger: 'change' }]
        this.$refs.specialistPage.validateField('Specialist.industryId')
        this.rules['Specialist.mobilePhone'] = [{ required: false, message: '请输入联系电话', trigger: 'change' }]
        this.$refs.specialistPage.validateField('Specialist.mobilePhone')
        this.rules['Specialist.birthday'] = [{ required: false, message: '请选择出生日期', trigger: 'change' }]
        this.$refs.specialistPage.validateField('Specialist.birthday')
      } else {
        this.myLabel.specialistNameLabel = '姓名';
        this.myLabel.specialistSpecialLabel = '专家特长简介';
        this.rules['Specialist.identityCardNo'] = [{ required: false, message: '请输入法人识别号', trigger: 'change' }]
        this.$refs.specialistPage.validateField('Specialist.identityCardNo')
        this.rules['Specialist.teamName'] = [{ required: false, message: '请输入团队名称', trigger: 'change' }]
        this.$refs.specialistPage.validateField('Specialist.teamName')
        this.rules['Specialist.industryId'] = [{ required: true, message: '请选择专业领域', trigger: 'change' }]
        this.rules['Specialist.birthday'] = [{ required: true, message: '请选择出生日期', trigger: 'change' }]
        this.rules['Specialist.mobilePhone'] = [{ required: true, message: '请输入联系电话', trigger: 'change' }]
      }
      // 个人才要填生日
      this.myFlag.birthdayFlag = true;
      if (value !== '1') {
        this.myFlag.birthdayFlag = false;
      }
    },
    /**
       * 性别下拉数据获取函数
       */
    loadGenderDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictGenderDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 性别选中值改变
       */
    onGenderValueChange (value) {
    },
    /**
       * 专业领域下拉数据获取函数
       */
    loadIndustryIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIndustryDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 专业领域选中值改变
       */
    onIndustryIdValueChange (value) {
      this.formData.Specialist.industryId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
       * 所在地区下拉数据获取函数
       */
    loadServiceAreaIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAreaDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 所在地区选中值改变
       */
    onServiceAreaIdValueChange (value) {
      this.formData.SpecialistHis.serviceAreaId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
       * 学位下拉数据获取函数
       */
    loadDegreeLevelDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictDegreeLevelDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 学位选中值改变
       */
    onDegreeLevelValueChange (value) {
    },
    /**
       * 学历下拉数据获取函数
       */
    loadEducationDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictEducationDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 学历选中值改变
       */
    onEducationValueChange (value) {
    },
    /**
       * 职称下拉数据获取函数
       */
    loadSpecialistTitleIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysTitlesDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 职称选中值改变
       */
    onSpecialistTitleIdValueChange (value) {
    },

    /**
       * 派驻站点下拉数据获取函数
       */
    loadStationIdsDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysDeptByParentId(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 派驻站点选中值改变
       */
    onStationIdsValueChange (value) {
    },
    /**
       * 地区ID下拉数据获取函数
       */
    loadAreaIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAreaDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 地区ID选中值改变
       */
    onAreaIdValueChange (value) {
      this.formData.Specialist.areaId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
       * 证件类型下拉数据获取函数
       */
    loadDocumentTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictDocumentTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 证件类型选中值改变
       */
    onDocumentTypeValueChange (value) {
    },
    /**
       * 身份下拉数据获取函数
       */
    loadIdentityDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIdentityDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 身份选中值改变
       */
    onIdentityValueChange (value) {
    },
    /**
       * 区级下拉数据获取函数
       */
    loadIsDistrictDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictDistrictDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 区级选中值改变
       */
    onIsDistrictValueChange (value) {
    },
    /**
       * 是否明星专家下拉数据获取函数
       */
    loadStarFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 是否明星专家选中值改变
       */
    onStarFlagValueChange (value) {
    },
    /**
       * 是否热门专家下拉数据获取函数
       */
    loadHotFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 是否热门专家选中值改变
       */
    onHotFlagValueChange (value) {
    },
    /**
       * 更新专家详情
       */
    refreshSpecialistPage (reloadData = false) {
      this.loadSpecialistData().then(res => {
        if (!this.specialistPage.isInit) {
          // 初始化下拉数据
          // this.specialistPage.specialistType.impl.onVisibleChange(true).catch(e => {});
          // this.specialistPage.serviceAreaId.impl.onVisibleChange(true).then(res => {
          //   this.specialistPage.serviceAreaId.value = findTreeNodePath(res, this.formData.Specialist.serviceAreaId, 'id');
          // }).catch(e => {});
          // this.specialistPage.starFlag.impl.onVisibleChange(true).catch(e => {});
          // this.specialistPage.hotFlag.impl.onVisibleChange(true).catch(e => {});
        }
        this.specialistPage.isInit = true;
      }).catch(e => {});
    },
    /**
       * 专家对接历史数据获取函数，返回Promise
       */
    loadSpecialistHisWidgetData (params) {
      if (params == null) params = {};
      let _specialistId = this.id;
      if (_specialistId === undefined) {
        _specialistId = -1;
      }
      params = {
        ...params,
        specialistHisDtoFilter: {
          specialistId: _specialistId,
          auditStatus: '1'
        }
      }
      return new Promise((resolve, reject) => {
        SpecialistHisController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.hisTab.SpecialistHis.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.hisTab.SpecialistHis.impl.currentRow.id, 'id');
              this.$refs.specialistHis.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 专家对接历史数据获取检测函数，返回true正常获取数据，返回false停止获取数据
       */
    loadSpecialistHisVerify () {
      return true;
    },
    /**
       * 更新服务历史
       */
    refreshHisTab (reloadData = false) {
      if (reloadData) {
        this.hisTab.SpecialistHis.impl.refreshTable(true, 1);
      } else {
        this.hisTab.SpecialistHis.impl.refreshTable();
      }
      if (!this.hisTab.isInit) {
        // 初始化下拉数据
      }
      this.hisTab.isInit = true;
    },
    /**
       * 查看编辑
       */
    onSignContractWinClick (row) {
      let params = {
        id: row.id,
        specialistId: row.specialistId
      };

      this.$dialog.show('查看编辑', signContractWin, {
        area: '800px'
      }, params).then(res => {
        this.hisTab.SpecialistHis.impl.refreshTable();
      }).catch(e => {});
    },
    onResume () {
      let activeFragment = this.getActiveFragment();
      if (activeFragment != null) activeFragment.refresh();
    },
    /**
       * 获取专家主表详细信息
       */
    loadSpecialistData () {
      let that = this
      return new Promise((resolve, reject) => {
        if (!this.formData.Specialist.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          SpecialistController.view(this, params).then(res => {
            this.formData.Specialist = {...res.data, isDatasourceInit: true};
            if (that.formData.Specialist.specialistMemberList && res.data.specialistType === '2') {
              that.formData.Specialist.specialistMemberList = res.data.specialistMemberList
              that.flowSpecialistAuditForm.SpecialistMember.impl.dataList = res.data.specialistMemberList
              that.flowSpecialistAuditForm.SpecialistMember.impl.totalCount = res.data.specialistMemberList.length
            }
            let specialistAvatarDownloadParams = {
              id: this.formData.Specialist.id,
              fieldName: 'specialistAvatar',
              asImage: true
            }

            this.flowSpecialistAuditForm.specialistAvatar.impl.fileList = this.parseUploadData(this.formData.Specialist.specialistAvatar, specialistAvatarDownloadParams);

            let idPhotoDownloadParams = {
              id: this.formData.Specialist.id,
              fieldName: 'idPhoto',
              asImage: true
            }
            this.flowSpecialistAuditForm.idPhoto.impl.fileList = this.parseUploadData(this.formData.Specialist.idPhoto, idPhotoDownloadParams);

            this.flowSpecialistAuditForm.gender.impl.onVisibleChange(true).catch(e => {});
            let educationalFileDownloadParams = {
              id: this.formData.Specialist.id,
              fieldName: 'educationalFile',
              asImage: true
            }
            this.flowSpecialistAuditForm.educationalFile.impl.fileList = this.parseUploadData(this.formData.Specialist.educationalFile, educationalFileDownloadParams);
            let degreeFilesDownloadParams = {
              id: this.formData.Specialist.id,
              fieldName: 'degreeFiles',
              asImage: true
            }
            this.flowSpecialistAuditForm.degreeFiles.impl.fileList = this.parseUploadData(this.formData.Specialist.degreeFiles, degreeFilesDownloadParams);
            let positionalFilesDownloadParams = {
              id: this.formData.Specialist.id,
              fieldName: 'positionalFiles',
              asImage: true
            }
            this.flowSpecialistAuditForm.positionalFiles.impl.fileList = this.parseUploadData(this.formData.Specialist.positionalFiles, positionalFilesDownloadParams);
            let servicePhotoDownloadParams = {
              id: this.formData.Specialist.id,
              fieldName: 'servicePhoto',
              asImage: true
            }
            this.flowSpecialistAuditForm.servicePhoto.impl.fileList = this.parseUploadData(this.formData.Specialist.servicePhoto, servicePhotoDownloadParams);

            let otherFilesDownloadParams = {
              id: this.formData.Specialist.id,
              fieldName: 'otherFiles',
              asImage: false
            }
            // if (!this.formData.Specialist.specialistMemberList) {
            //   this.formData.Specialist.specialistMemberList = []
            // }
            this.flowSpecialistAuditForm.specialistType.impl.onVisibleChange(true).catch(e => {});
            this.flowSpecialistAuditForm.appropriateChannel.impl.onVisibleChange(true).catch(e => {});
            // this.flowSpecialistAuditForm.SpecialistMember.impl.dataList = this.formData.Specialist.specialistMemberList
            // this.flowSpecialistAuditForm.SpecialistMember.impl.totalCount = this.formData.Specialist.specialistMemberList.length
            this.flowSpecialistAuditForm.otherFiles.impl.fileList = this.parseUploadData(this.formData.Specialist.otherFiles, otherFilesDownloadParams);
            this.flowSpecialistAuditForm.stationIds.impl.onVisibleChange(true).catch(e => {});

            this.flowSpecialistAuditForm.degreeLevel.impl.onVisibleChange(true).catch(e => {});
            this.flowSpecialistAuditForm.industryId.impl.onVisibleChange(true).catch(e => {});
            this.flowSpecialistAuditForm.specialistTitleId.impl.onVisibleChange(true).catch(e => {});
            this.flowSpecialistAuditForm.identity.impl.onVisibleChange(true).catch(e => {});
            this.flowSpecialistAuditForm.isDistrict.impl.onVisibleChange(true).catch(e => {});
            this.flowSpecialistAuditForm.documentType.impl.onVisibleChange(true).catch(e => {});
            this.flowSpecialistAuditForm.education.impl.onVisibleChange(true).catch(e => {});

            // this.onSpecialistTypeValueChange(this.formData.Specialist.specialistType)

            // this.specialistPage.starFlag.impl.onVisibleChange(true).catch(e => {});
            // this.specialistPage.hotFlag.impl.onVisibleChange(true).catch(e => {});

            let params2 = {
              specialistHisDtoFilter: {
                specialistInfoId: this.formData.Specialist.infoId
              }
            }
            // alert(1111)
            // 获取服务签约信息
            SpecialistHisController.list(this, params2).then(res => {
              if (res.data.dataList.length > 0) {
                that.formData.SpecialistHis = res.data.dataList[0]
                let contractFilesDownloadParams = {
                  id: that.formData.SpecialistHis.id,
                  fieldName: 'contractFiles',
                  asImage: false
                }

                let attachedFilesDownloadParams = {
                  id: that.formData.SpecialistHis.id,
                  fieldName: 'attachedFiles',
                  asImage: false
                }

                that.signContractWin.serviceAreaId.impl.onVisibleChange(true).catch(e => {});
                that.signContractWin.contractFiles.impl.fileList =
                    that.parseUploadData(that.formData.SpecialistHis.contractFiles, contractFilesDownloadParams);
                that.signContractWin.attachedFiles.impl.fileList =
                    that.parseUploadData(that.formData.SpecialistHis.attachedFiles, attachedFilesDownloadParams);
              }
            })

            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.Specialist.isDatasourceInit = true;
          resolve();
        }
      });
    },
    /**
       * 删除
       */
    onDeleteClick (row, index) {
      this.$confirm('是否删除?').then(res => {
        index = (this.currentPage - 1) * this.PageSize + index
        this.formData.Specialist.specialistMemberList.splice(index, 1);
        console.log('删除row', row, index)
        this.$message.success('删除成功');
        this.flowSpecialistAuditForm.SpecialistMember.impl.dataList = this.formData.Specialist.specialistMemberList
        this.flowSpecialistAuditForm.SpecialistMember.impl.totalCount = this.formData.Specialist.specialistMemberList.length
        this.flowSpecialistAuditForm.SpecialistMember.impl.refreshTable();
      }).catch(e => {});
    },
    /**
       * 编辑
       */
    onSpecialistMemberEditClick (row, index) {
      let params = {
        specialistMemberForm: row
      };
      console.log('indexindexindexindexindex', this.currentPage, index)
      this.$dialog.show('编辑', specialistMemberEdit, {
        area: '800px'
      }, params).then(res => {
        if (index === -1) {
          this.$message.success('编辑失败');
        } else {
          index = (parseInt(this.currentPage) - 1) * this.PageSize + index
          this.formData.Specialist.specialistMemberList[index] = res.specialistMemberDto
          console.log('totalAmount11111111111111', index, this.formData.Specialist.specialistMemberList[index], this.formData.Specialist.specialistMemberList, this.formData.Specialist.specialistMemberList)
          this.flowSpecialistAuditForm.SpecialistMember.impl.dataList = this.formData.Specialist.specialistMemberList
          this.flowSpecialistAuditForm.SpecialistMember.impl.totalCount = this.formData.Specialist.specialistMemberList.length
          this.refreshSpecialistMemberList();
          // this.budgetDetailPage.BudgetDetail.impl.refreshTable();
          this.flowSpecialistAuditForm.SpecialistMember.impl.refreshTable();
          this.formData.Specialist.specialistMemberList.splice(1, 0);
        }
      }).catch(e => {});
    },
    /**
       * 新增
       */
    addSpecialistMember () {
      let params = {};

      this.$dialog.show('新增', specialistMemberForm, {
        area: '800px'
      }, params).then(res => {
        console.log('resresresresresres', res, this.formData.Specialist.specialistMemberList)
        var size = this.formData.Specialist.specialistMemberList.length
        console.log('sizesizesize', size)
        this.formData.Specialist.specialistMemberList[size] = res.specialistMemberDto
        console.log('this.formData.Specialist.specialistMemberList', this.formData.Specialist.specialistMemberList)
        this.flowSpecialistAuditForm.SpecialistMember.impl.dataList = this.formData.Specialist.specialistMemberList
        this.flowSpecialistAuditForm.SpecialistMember.impl.totalCount = this.formData.Specialist.specialistMemberList.length
        this.refreshSpecialistMemberList();
        this.formData.Specialist.specialistMemberList.splice(1, 0);
      }).catch(e => {});
    },
    /**
       * 更新团队成员列表
       */
    refreshSpecialistMemberList (reloadData = false) {
      this.flowSpecialistAuditForm.SpecialistMember.impl.dataList = this.formData.Specialist.specialistMemberList
      this.flowSpecialistAuditForm.SpecialistMember.impl.totalCount = this.formData.Specialist.specialistMemberList.length
      this.flowSpecialistAuditForm.SpecialistMember.impl.refreshTable();
    },
    handleSizeChange (val) {
      // 改变每页显示的条数
      this.PageSize = val
      // 在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1
    },
    // 显示第几页
    handleCurrentChange (val) {
      // 改变默认的页数
      this.currentPage = val
    },
    /**
       * 获取专家对接历史详细信息
       */
    loadSpecialistHisData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.SpecialistHis.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          SpecialistHisController.view(this, params).then(res => {
            this.formData.SpecialistHis = {...res.data, isDatasourceInit: true};
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.SpecialistHis.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    buildFragmentPermCodeMap () {
      this.permCodeList = [
        {
          key: 'specialistPage',
          permCode: 'specialistPage:specialistPage',
          refresh: this.refreshSpecialistPage
        },
        {
          key: 'hisTab',
          permCode: 'specialistPage:hisTab',
          refresh: this.refreshHisTab
        }
      ];
    },
    onFragmentChange (fragmentId) {
      for (let i = 0; i < this.permCodeList.length; i++) {
        if (this.permCodeList[i].key === fragmentId) {
          this.activeFragmentId = fragmentId;
          if (this.permCodeList[i].refresh) this.permCodeList[i].refresh();
          return true;
        }
      }
      return false;
    },
    getActiveFragment () {
      for (let i = 0; i < this.permCodeList.length; i++) {
        if (this.permCodeList[i].key === this.activeFragmentId) {
          return this.permCodeList[i];
        }
      }
    },
    /**
       * 照片上传成功
       */
    onSpecialistAvatarUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistAuditForm.specialistAvatar.impl.onFileChange(file, fileList);
        this.formData.Specialist.specialistAvatar = this.fileListToJson(this.flowSpecialistAuditForm.specialistAvatar.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除照片
       */
    onSpecialistAvatarRemoveFile (file, fileList) {
      this.flowSpecialistAuditForm.specialistAvatar.impl.onFileChange(file, fileList);
      this.formData.Specialist.specialistAvatar = this.fileListToJson(this.flowSpecialistAuditForm.specialistAvatar.impl.fileList);
    },
    /**
       * 学历资料上传成功
       */
    onEducationalFileUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistAuditForm.educationalFile.impl.onFileChange(file, fileList);
        this.formData.Specialist.educationalFile = this.fileListToJson(this.flowSpecialistAuditForm.educationalFile.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除学历资料
       */
    onEducationalFileRemoveFile (file, fileList) {
      this.flowSpecialistAuditForm.educationalFile.impl.onFileChange(file, fileList);
      this.formData.Specialist.educationalFile = this.fileListToJson(this.flowSpecialistAuditForm.educationalFile.impl.fileList);
    },
    /**
       * 职称资料上传成功
       */
    onPositionalFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistAuditForm.positionalFiles.impl.onFileChange(file, fileList);
        this.formData.Specialist.positionalFiles = this.fileListToJson(this.flowSpecialistAuditForm.positionalFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除职称资料
       */
    onPositionalFilesRemoveFile (file, fileList) {
      this.flowSpecialistAuditForm.positionalFiles.impl.onFileChange(file, fileList);
      this.formData.Specialist.positionalFiles = this.fileListToJson(this.flowSpecialistAuditForm.positionalFiles.impl.fileList);
    },
    /**
       * 学位资料上传成功
       */
    onDegreeFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistAuditForm.degreeFiles.impl.onFileChange(file, fileList);
        this.formData.Specialist.degreeFiles = this.fileListToJson(this.flowSpecialistAuditForm.degreeFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除学位资料
       */
    onDegreeFilesRemoveFile (file, fileList) {
      this.flowSpecialistAuditForm.degreeFiles.impl.onFileChange(file, fileList);
      this.formData.Specialist.degreeFiles = this.fileListToJson(this.flowSpecialistAuditForm.degreeFiles.impl.fileList);
    },
    /**
       * 其他附件上传成功
       */
    onOtherFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistAuditForm.otherFiles.impl.onFileChange(file, fileList);
        this.formData.Specialist.otherFiles = this.fileListToJson(this.flowSpecialistAuditForm.otherFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除其他附件
       */
    onOtherFilesRemoveFile (file, fileList) {
      this.flowSpecialistAuditForm.otherFiles.impl.onFileChange(file, fileList);
      this.formData.Specialist.otherFiles = this.fileListToJson(this.flowSpecialistAuditForm.otherFiles.impl.fileList);
    },
    deleteOtherFiles (file, fileList, index) {
      fileList.splice(index, 1)
      this.onOtherFilesRemoveFile(file, fileList)
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    /**
       * 重置表单数据
       */
    resetFormData () {
      this.formData = {
        SpecialistHis: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          specialistId: undefined,
          specialistName: undefined,
          serviceObjectName: undefined,
          serviceAreaId: undefined,
          serviceAreaName: undefined,
          contactsUser: undefined,
          contactsUserTel: undefined,
          mainBusiness: undefined,
          signYear: undefined,
          serviceUserRequirement: undefined,
          serviceType: undefined,
          serviceContent: undefined,
          contractFiles: undefined,
          attachedFiles: undefined,
          isDatasourceInit: false
        },
        Specialist: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          specialistType: undefined,
          specialistName: undefined,
          teamName: undefined,
          specialistAvatar: undefined,
          mobilePhone: undefined,
          gender: undefined,
          specialistSpecial: undefined,
          companyName: undefined,
          specialistTitle: undefined,
          companyTel: undefined,
          birthday: undefined,
          educationalFile: undefined,
          companyContacts: undefined,
          companyPost: undefined,
          degreeFiles: undefined,
          specialistTitleId: undefined,
          companyContactsTel: undefined,
          degreeLevel: undefined,
          positionalFiles: undefined,
          otherFiles: undefined,
          auditStatus: undefined,
          hotFlag: undefined,
          userId: undefined,
          areaId: undefined,
          hotScore: undefined,
          industryName: undefined,
          relateId: undefined,
          areaName: undefined,
          industryId: undefined,
          starFlag: undefined,
          stationIds: undefined,
          associationStation: undefined,
          identityCardNo: undefined,
          mainBusiness: undefined,
          serviceType: undefined,
          serviceContent: undefined,
          serviceObjectName: undefined,
          signYear: undefined,
          serviceAreaId: undefined,
          serviceAreaName: undefined,
          contactsUser: undefined,
          contactsUserTel: undefined,
          serviceUserRequirement: undefined,
          isDatasourceInit: false
        }
      }
      this.getDefaultFragment();
    },
    saveSpecialist () {
      if (this.formData.Specialist.specialistType === '2' && this.formData.Specialist.specialistMemberList.length === 0) {
        this.$message.error('请新增团队成员信息！');
      } else {
        this.$refs.specialistPage.validate((valid) => {
          if (!valid) {
            this.$message.error('信息不完整，请检查！');
            return;
          }
          this.$confirm('是否保存？').then(res => {
            this.formData.Specialist.signYearStart = this.formData.SpecialistHis.signYearStart
            this.formData.Specialist.signYearEnd = this.formData.SpecialistHis.signYearEnd
            let params = {
              specialistDto: {
                ...this.formData.Specialist
              },
              specialistHisDto: {
                ...this.formData.SpecialistHis
              }
            };
            SpecialistController.update(this, params).then(res => {
              this.$message.success('保存成功');
              this.onCancel(true)
            }).catch(e => {});
          }).catch(e => {});
        });
      }
    },

    /**
     * 证件照上传成功
     */
    onIdPhotoUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistAuditForm.idPhoto.impl.onFileChange(file, fileList);
        this.formData.Specialist.idPhoto = this.fileListToJson(this.flowSpecialistAuditForm.idPhoto.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除证件照
     */
    onIdPhotoAvatarRemoveFile (file, fileList) {
      this.flowSpecialistAuditForm.idPhoto.impl.onFileChange(file, fileList);
      this.formData.Specialist.idPhoto = this.fileListToJson(this.flowSpecialistAuditForm.idPhoto.impl.fileList);
    },

    /**
     * 服务单位营业执照
     */
    onServicePhotoUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.flowSpecialistAuditForm.servicePhoto.impl.onFileChange(file, fileList);
        this.formData.Specialist.servicePhoto = this.fileListToJson(this.flowSpecialistAuditForm.servicePhoto.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除服务单位营业执照
     */
    onServicePhotoRemoveFile (file, fileList) {
      this.flowSpecialistAuditForm.servicePhoto.impl.onFileChange(file, fileList);
      this.formData.Specialist.servicePhoto = this.fileListToJson(this.flowSpecialistAuditForm.servicePhoto.impl.fileList);
    },
    /**
     * 移除其他附件
     */
    onAttachedFilesRemoveFile (file, fileList) {
      this.signContractWin.attachedFiles.impl.onFileChange(file, fileList);
      this.formData.SpecialistHis.attachedFiles = this.fileListToJson(this.signContractWin.attachedFiles.impl.fileList);
    },
    deleteAttachedFiles (file, fileList, index) {
      fileList.splice(index, 1)
      this.onAttachedFilesRemoveFile(file, fileList)
    },
    /**
     * 其他附件上传成功
     */
    onAttachedFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.signContractWin.attachedFiles.impl.onFileChange(file, fileList);
        this.formData.SpecialistHis.attachedFiles = this.fileListToJson(this.signContractWin.attachedFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 三方协议书上传成功
     */
    onContractFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.signContractWin.contractFiles.impl.onFileChange(file, fileList);
        this.formData.SpecialistHis.contractFiles = this.fileListToJson(this.signContractWin.contractFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除三方协议书
     */
    onContractFilesRemoveFile (file, fileList) {
      this.signContractWin.contractFiles.impl.onFileChange(file, fileList);
      this.formData.SpecialistHis.contractFiles = this.fileListToJson(this.signContractWin.contractFiles.impl.fileList);
    },

    /**
       * 根据权限获取默认显示的fragment
       */
    getDefaultFragment () {
      for (let i = 0; i < this.permCodeList.length; i++) {
        if (this.checkPermCodeExist(this.permCodeList[i].permCode)) {
          this.activeFragmentId = this.permCodeList[i].key;
          return this.permCodeList[i];
        }
      }
      return undefined;
    },
    formInit () {
      let defaultFragment = this.getDefaultFragment();
      if (defaultFragment == null) {
        this.$message.error('您没有访问这个页面的权限，请与系统管理员联系！');
      }
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    }
  },
  computed: {
    getTabPaneHeight () {
      return (this.getMainContextHeight - 102);
    },
    ...mapGetters(['getMainContextHeight'])
  },
  mounted () {
    this.formInit();
  },
  created () {
    this.buildFragmentPermCodeMap();
  },
  watch: {
  }
}
</script>
<style>
  .el-input.is- .el-input__inner {
    background-color: white!important;
    color: #0f1325!important;
  }
</style>
